export const generateRandomId = ():number => {
    // Generate a random integer between 1 and 1000000
    return Math.floor(Math.random() * 1000000) + 1;
}